if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swiperElement = this.querySelector('.swiper');

      this.slider = new Swiper(this.swiperElement, {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        on: {
          slideChange: (swiper) => {
            const activeSlide = swiper.slides[swiper.activeIndex];
            this.style.setProperty(
              '--text-color',
              activeSlide.getAttribute('js-color') ||
                '#fff',
            );

            window.pauseAllMedia();

            activeSlide.querySelectorAll('video').forEach(video => video.play());
          },
        },
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);
}
